export const getFoodMenuProfile = state => {
    
    let jsonReqData
    jsonReqData = {
        id: state.props.id,
        menu_title: state.props.menu_title,
        sales_price: state.props.sales_price,
        suggested_base_price: state.props.suggested_base_price,
        suggested_profit_percent: state.props.suggested_profit_percent,
        suggested_sales_price: state.props.suggested_sales_price,
        banner_image: state.props.banner_image,
        availability: state.props.availability,
        sub_menus: JSON.stringify(state.props.sub_menus)
    }
    
    //return
    return jsonReqData

}

export const getFoodMenuList = state => {
    if(state.filterText.length>0) {
        return state.list.filter(function (element) {
            return element.menu_title.toLowerCase().match(state.filterText.toLowerCase())
        });
        
    } else {
        return state.list
    }
    
}

export const getFinalFoodList = state => {
    return state.final_list
}

export const getSelectedSubMenus = state => {
    return state.props.sub_menus
}

export const getMenuEdit = state => {
    return state.menu_edit
}


// WEBPACK FOOTER //
// ./src/store/modules/foodMenus/getters.js